import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { PhoneInputComponent } from '../../inputs/phone-input/phone-input.component';

@Component({
  selector: 'lib-phone-form-field',
  imports: [FormErrorComponent, PhoneInputComponent, ReactiveFormsModule],
  templateUrl: './phone-form-field.component.html',
  styleUrl: './phone-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  countryCodeFormControl = input.required<FormControl>();
  inputId: string = uuidv4();
}
